<template>
<v-btn color="primary" style="float: right;" :disabled="disableBtn()" @click="waitlist">Wait List</v-btn>
</template>

<script>
export default {
    props: {
        semester: {
            type: Object,
            required: true
        },
        course: {
            type: Object,
            required: true
        }
    },
    computed: {
        enrolledClasses() {
            return this.$store.state.enrollment.schedule.enrolled
        },
        waitlistClasses() {
            return this.$store.state.enrollment.schedule.waiting
        }
    },
    methods: {
        disableBtn() {
            /*
              waitlist restrictions are more lenient, there are many
              possible ways a students schedule can turn out, don't want
              to limit them from trying to get a class they want.
            */
            let result = false
            this.waitlistClasses.forEach((c) => {
                // check if student is already waitlisted
                if (c.id === this.course.id) {
                    result = true
                }
            })
            this.enrolledClasses.forEach((c) => {
                // check if student is enrolled in the class
                if (c.id === this.course.id) {
                    result = true
                }
            })
            // so parents can see classes, but not interact with them
            if (this.semester.disabled) {
                result = true
            }
            return result
        },
        waitlist() {
            this.$root.$emit('waitlistCourse', this.course)
        }
    }
}
</script>
